import { ObjectValues } from "types";

const QuestionInsightDisplayModes = {
  ANSWER_DIFFERENCES: "",
  TRAIT_DIFFERENCES: "Reverse",
  BRIEF_NARRATIVE: "NarrativeSummary",
  FULL_NARRATIVE: "NarrativeFull",
} as const;

export type QuestionInsightDisplayMode = ObjectValues<typeof QuestionInsightDisplayModes>;

export default QuestionInsightDisplayModes;
